import React from 'react';

import PercentField from '../PercentField';

const PercentControl = ({
  value,
  onChange,
  onTouch,
  validationState,
  errorMessages,
  ...restOfProps
}) => {
  const { dirty, pending, touched, valid, ...restOfValidation } = validationState;

  const hasError = (dirty || touched) && !valid;

  const errors = Object.keys(restOfValidation).reduce((prev, key) => {
    if (!restOfValidation[key]) {
      return [...prev, errorMessages[key]];
    }
    return prev;
  }, []);

  return (
    <PercentField
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={() => onTouch()}
      error={hasError}
      helperText={hasError ? errors.join(', ') : undefined}
      {...restOfProps}
    />
  );
};

export default PercentControl;
